import { type MetaFunction } from '@remix-run/node'
import { useSearchParams } from '@remix-run/react'

export const meta: MetaFunction = () => {
	return [{ title: 'Document Fullscreen | refundr' }]
}

export default function DocumentsFullscreenRoute() {
	const [searchParams] = useSearchParams()
	const type = searchParams.get('type')
	const link = searchParams.get('link') as string
	const title = searchParams.get('title') as string

	return (
		<div className="flex flex-col items-center justify-center pb-14">
			<div className="my-6 text-center">
				<h3 className="text-h3">{title ? title : 'Document'}</h3>
			</div>
			<div className="mt-2 flex h-full w-10/12 items-center justify-center text-center">
				{type?.startsWith('image') && (
					<div className="mt-6 flex h-full w-full items-center justify-center text-center">
						<img
							src={link}
							className="h-full max-h-full w-full max-w-full rounded-t-lg border-x border-t border-gray-200 object-contain  object-center group-hover:opacity-75"
						/>
					</div>
				)}
				{type?.startsWith('pdf') && (
					<div className="flex h-screen w-full flex-col items-center">
						<embed
							src={link}
							className="h-full w-full rounded-t-lg border-x border-t border-gray-200 object-cover object-center group-hover:opacity-75"
						/>
					</div>
				)}
			</div>
		</div>
	)
}
